import axiosPost from '../axiosPost';

export const rubrosDeMerchantGet = async (arg) => {
    const { params } = arg;
    const body = {
        "service": "RubroDeMerchantGet",
        "params": params ? params : {}
    }
    
    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } catch (err) {
        console.log(err)
    }
};